import { useState, useEffect, useMemo } from 'react';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import _orderBy from 'lodash/orderBy';

import { lazyGetLotteryPrizeList } from 'client/redux/modules/lotteryPrizes';
import { lazyGetMGMtLotteryPrizeList } from 'client/redux/modules/mgmReferral';

const animatingLotteryAndPrizeSelector = createSelector(
    [s => s.flags, s => s.lotteryPrizes, s => s?.mgmReferral?.lotteryPrizes ?? {}],
    (flags, lotteryPrizes = {}, mgmLotteryPrizes = {}) => {
        const { animatingLotteries } = flags;
        const prizes = { ...mgmLotteryPrizes, ...lotteryPrizes };
        return {
            lotteryUUID: animatingLotteries.uuid,
            lotteryPrizes: prizes
        };
    }
);

export function usePurePrizeGamePrizeList() {
    const { lotteryUUID, lotteryPrizes } = useSelector(animatingLotteryAndPrizeSelector);
    const { hasInited } = useSelector(s => s.flags);
    const prizeList = lotteryPrizes[lotteryUUID];
    return useMemo(() => (hasInited ? _orderBy(prizeList ?? [], ['displaySeq']) : null), [
        hasInited,
        prizeList
    ]);
}

export function useAnimationPathPrizeList(lotteryUUID, isMgmShare, isMgmSelf) {
    const dispatch = useDispatch();
    const [prizeList, setPrizeList] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                let prizes = [];
                if (isMgmShare || isMgmSelf) {
                    prizes = await dispatch(lazyGetMGMtLotteryPrizeList({ lotteryUUID }));
                } else {
                    prizes = await dispatch(lazyGetLotteryPrizeList({ lotteryUUID }));
                }
                const sortPrizes = _orderBy(prizes, ['displaySeq']);
                setPrizeList(sortPrizes);
            } catch (error) {
                console.log(error);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lotteryUUID]);

    return prizeList;
}
